import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export interface DisplayHeadingProps extends HTMLAttributes<HTMLHeadingElement> {
  level?: 1 | 2 | 3;
  balance?: boolean;
}

const SIZE_CLASSES: Record<NonNullable<DisplayHeadingProps["level"]>, string> = {
  1: "text-[clamp(2.5rem,5vw,4.5rem)] leading-[1.05]",
  2: "text-[clamp(2rem,4vw,3.25rem)] leading-[1.1]",
  3: "text-[clamp(1.5rem,3vw,2.25rem)] leading-[1.15]",
};

export const DisplayHeading = forwardRef<HTMLHeadingElement, DisplayHeadingProps>(function DisplayHeading(
  { level = 1, balance = true, className, children, ...rest },
  ref,
) {
  const Tag = (`h${level}` as unknown) as "h1";
  return (
    <Tag
      ref={ref}
      className={cn(
        "text-display tracking-tight font-medium text-foreground",
        SIZE_CLASSES[level],
        balance && "[text-wrap:balance]",
        className,
      )}
      {...rest}
    >
      {children}
    </Tag>
  );
});
